import React from 'react';
import ReactDOM from 'react-dom';
import App from './App';
import registerServiceWorker from './registerServiceWorker';

import demo_tour from './demo_tour';
window.hopscotch = require('hopscotch');

ReactDOM.render(<App />, document.getElementById('root'));
registerServiceWorker();

window.keencorp = {};
window.keencorp.date_enabled = false;
window.keencorp.date_changed = false;
window.keencorp.tour = demo_tour;



// WEBPACK FOOTER //
// ./src/index.js